import { Tag } from 'antd';
import styles from './cell-renderers.module.scss';

/**
 * AG Grid cell renderer that displays an array of values as tags.
 *
 * @param {import('ag-grid-community').ICellRendererParams} params
 */
export function TagListCell({ value }) {
  if (!value || !Array.isArray(value) || value.length === 0) {
    return '-';
  }

  return (
    <div className={styles.tagContainer}>
      {value.map(item => (
        <Tag key={item}>{item}</Tag>
      ))}
    </div>
  );
}
